import { combineReducers } from "redux";
import orgsReducer from "./orgsReducer";

import errorReducer from "./errorReducer";
import authReducer from "./authReducer";

export default combineReducers({
  orgs: orgsReducer,
  error: errorReducer,
  auth: authReducer
});
